import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { usePastEvent } from "src/hooks/usePastEvent";
import { useTranslation } from "react-i18next";
import PastEventWinnersContent from "./PastEventWinnersContent";

const PastEventWinners = () => {
  const location = useLocation();
  const { eventSlug } = useParams();
  const { i18n } = useTranslation();

  const { event: currentEvent } = usePastEvent(
    eventSlug,
    location.pathname,
    i18n.language
  );

  return <PastEventWinnersContent event={currentEvent} />;
};

export default PastEventWinners;
